import { getAll } from '../../utils/api';
import { services } from '../../constants/services';
import { InitDataDto } from '../dtos/initData.dto';

export const GetInitDataService = async (roleId: number | string = '') => {

  const response = await getAll<InitDataDto>(`${services.users}/access/users/get-init-data?role_id=${roleId}`);
  return response;
};
